<ion-menu-button class="pulse-btn">
  <ion-icon src="./assets/img/custom-menu.svg"></ion-icon>
</ion-menu-button>
